import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {HttpService} from './http.service';
import {UtilService} from './util.service';
import {environment} from '../../../environments/environment';
import {LoaderService} from './loader.service';

@Injectable()
export class MarketingService {
  constructor(
    private http: HttpService,
    private utilService: UtilService,
    private loaderService: LoaderService
  ) {
  }

  getCatalogs(isFilterVal) {
    const hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/catalog/getCatalogsByHotelChain/${hotelChainId}?isFilter=${isFilterVal}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getRewards(options) {
    const url = `/rewards-catalog/getRewardsCatalog`;
    options.hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.post(url, options)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getCatalogById(catalogId) {
    return this.http.get(`/catalog/getCatalogByCatalogId/${catalogId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getRewardsByHotelChainId() {
    return this.http.get(`/rewards-catalog/getRewardsByHotelChainId`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHotelsByRewardCatalogId(rewardCatalogId) {
    return this.http.get(`/rewards-catalog/getHotelsByRewardCatalogId/${rewardCatalogId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getLoyaltyLevels(programTypeId: any) {
    const hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/catalog/getMembershipLevelsByHotelChain/${hotelChainId}?programType=${programTypeId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  addCatalog(data, isNew) {
    const url = isNew ? `/catalog/createCatalog` : `/catalog/modifyCatalog`;
    data.hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.post(url, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateCatalog(catalogId, status) {
    return this.http.get(`/catalog/activateOrDeactivateCatalog/${catalogId}/${status}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getPromotionRules() {
    const hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/promo/getPromoCodeLookupData/${hotelChainId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getPromotionData(data) {
    data.hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.post(`/promo/getPromotionsList`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getRewardProductTypes() {
    return this.http.get(`/rewards-catalog/getRewardProductTypes`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getCurrencyTypes() {
    return this.http.get(`/rewards-catalog/getCurrencyTypes`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getServiceProviders() {
    return this.http.get(`/rewards-catalog/getServiceProviders`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getTransactionTypes(type?) {
    return this.http.get(`/promo/getTransactionTypes${type ? '?isMember=true' : ''}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getPersonTypes() {
    return this.http.get(`/adminMember/getPersonType`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getPointValueTypes() {
    return this.http.get(`/promo/getPointValueTypes`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getScratchCode(quantity) {
    return this.http.get(`/promo/generateScratchCode?quantity=${quantity}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getPromoById(promoId) {
    return this.http.get(`/promo/getPromoById/${promoId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  addOrUpdatePromo(data) {
    return this.http.post(`/promo/addPromo`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getRewardById(rewardId) {
    return this.http.get(`/rewards-catalog/getRewardById/${rewardId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateRewardCatalog(reward, id) {
    const url = `/rewards-catalog/activeOrInactiveRewardCatalog`;
    const body = {'rewardsList': reward, 'statusId': id};
    return this.http.post(url, body)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivatePromos(promo, id) {
    const url = `/promo/activateOrDeactivatePromo/${id}`;
    return this.http.post(url, promo)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateReward(reward, status) {
    const url = `/rewards-catalog/activeOrInactiveRewardCatalog`;
    const body = {'reward': reward, 'statusId': status};
    return this.http.post(url, body)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  createRewardCatalog(reward) {
    this.loaderService.show();
    const url = `rewards-catalog/createRewardCatalog`;
    const myToken = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')).token : null;
    return Observable.create((observer) => {
      const xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this.loaderService.hide();
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            this.loaderService.hide();
            observer.error(JSON.parse(xhr.response));
          }
        }
        return () => {
          this.loaderService.hide();
          xhr.abort();
        };
      };
      xhr.open('POST', `${environment.BASE_API}${environment.ROLE}/${url}`, true);
      xhr.setRequestHeader('X-Auth-Token', myToken);
      xhr.send(reward);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/_services/marketing.service.ts